
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import region from '@/api/region/regionCity.ts';
  import {getAllWeather} from '@/api/third-platform';
  // import '@icon-park/vue/styles/index.css';
  // import {LightRain, Cloudy} from '@icon-park/vue';
  import {add} from '@/api/feedback.ts';

  @Component({
    components: {
      // LightRain,
      // Cloudy
    }
  })
  export default class Weather extends Vue {
    @Prop({required: true, default: () => false}) private show!: boolean;
    @Prop({default: () => []}) private menuTops!: any;

    private currentShow = this.show;
    private dialogShow = false;
    private formData = {
      title: '',
      phone: ''
    };

    private today = {
      dayTemp: '',
      nightTemp: '',
      dayWeather: ''
    };
    private tomorrow = {
      dayTemp: '',
      nightTemp: '',
      dayWeather: ''
    };

    private baseUrl = Vue.prototype.$appsettings.serverUrl + '/';

    private pattern = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;

    private cityName = '';

    private async mounted() {
      await this.getWeather();
    }

    get regionId() {
      return this.$store.getters.regionId;
    }

    get color() {
      let color = this.$store.getters.background;
      if (!color) {
        color = '#4B9CFC';
      }
      return color;
    }

    private async getWeather() {
      if (this.regionId) {
        await this.getTq();

        for (let item of region) {
          for (let temp of item.children) {
            if (temp.value === this.regionId.toString()) {
              this.cityName = temp.label;
              return;
            }
          }
        }
      }
    }

    private async getTq() {
      if (this.regionId) {
        const result = await getAllWeather(this.regionId.toString());
        if (result.status === 1) {
          if (result.forecasts.length > 0) {
            this.today = Object.assign({}, result.forecasts[0].casts[0]);
            this.tomorrow = Object.assign({}, result.forecasts[0].casts[1]);
          }
        }
      }
    }

    private handlerClose() {
      this.$emit('close', false);
    }

    private handleClickFeedback() {
      this.dialogShow = true;
      this.formData.title = '';
      this.formData.phone = '';
    }

    private validator(val: any) {
      if (val) {
        return this.pattern.test(val);
      }
      return true;
    }

    private async onSubmit(values: any) {
      this.dialogShow = false;
      await add(values);
      this.handlerClose();
    }
  }
